<template>
  <img src="@/assets/img/map-distance.svg" />
</template>

<script>
export default {};
</script>

<style></style>
